import { render, staticRenderFns } from "./hotHotel.vue?vue&type=template&id=38a65f98&scoped=true"
import script from "./hotHotel.vue?vue&type=script&lang=js"
export * from "./hotHotel.vue?vue&type=script&lang=js"
import style0 from "./hotHotel.vue?vue&type=style&index=0&id=38a65f98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a65f98",
  null
  
)

export default component.exports